import { render, staticRenderFns } from "./incourse_candidates_list.vue?vue&type=template&id=aff1e544&"
import script from "./incourse_candidates_list.vue?vue&type=script&lang=js&"
export * from "./incourse_candidates_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports